<template>
  <div class="flujo-fondos-presupuestos">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Presupuestos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="flujoFondosPresupuestos"
              :fields="fields"> 
              <!-- @row-clicked="consultar"> -->
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaPresupuestada)="data">
              {{ data.item.fechaPresupuestada | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-edit"></i>Borrar Presupuesto</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from  '../shared/listFiltroPeriodo.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'flujoFondosPresupuestos/getField',
  mutationType: 'flujoFondosPresupuestos/updateField',
});

export default {
  name:'FlujoFondosPresupuestosList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'fechaPresupuestada',
        },
        {
          key: 'flujoFondosConcepto',
          label: 'Concepto'
        },
        {
          key: 'importe',
          class: 'text-right'
        },
        {
          key: 'observaciones'
        },
        { 
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'flujoFondosPresupuestos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }   
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('flujoFondosPresupuestos/getFlujoFondosPresupuestos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    // consultar (item) {
    //   this.$router.push({ name: 'TarjetaVencimientoData', 
    //                       params: { id: item.id }});
    // },
    agregar () {
      this.$router.push({ name: 'FlujoFondosPresupuestoAdd' });
    },
    borrar (item) {
      this.showModalConfirm('¿Desea borrar el presupuesto seleccionado?', 
            this.borrarPresupuesto.bind(this, item.id), 'Si', null, 'No')
    },
    borrarPresupuesto (flujoFondosPresupuestoId) {
      this.showSpinner();
      this.$store.dispatch('flujoFondosPresupuestos/delete', flujoFondosPresupuestoId)
        .then(() => this.showModalMsj('El presupuesto seleccionado se eliminó con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
.flujo-fondos-presupuestos .registro table td {
  vertical-align: middle;
}
.flujo-fondos-presupuestos .registro table td[aria-colindex="1"] {
  width: 15%;
}
.flujo-fondos-presupuestos .registro table td[aria-colindex="2"] {
  width: 10%;
}
.flujo-fondos-presupuestos .registro table td[aria-colindex="3"] {
  width: 15%;
}
.flujo-fondos-presupuestos .registro table td[aria-colindex="4"] {
  width: calc(65% - 40px);
}
.flujo-fondos-presupuestos .registro table td[aria-colindex="5"] {
  width: 40px;
}

</style>
